import { useContext, useRef } from 'react';
import PageContext from '../sub-components/PageContext';
import { useSelector } from 'react-redux';
import ButtonComponent from './ButtonComponent';

const WorkflowButton = ({ disable }) =>{
    // initialize context from parent
    const {
        workflowModal,  
        setWorkflowModal, 
        workflowAction, 
        setWorkflowAction,
        workflowNewStatus, 
        setWorkflowNewStatus, 
        workflowButtonCss,  
        workflowOptOut, // flag to allow toggle to opt out of rebate workflow
        workflowReviewAction, // flag to determine whether to show dropdown
        userEntitlementId, 
        status, 
        enableReopen, // flag to enable button for reopen action 
        workflowActionId, 
        setWorkflowActionId, 
    } = useContext(PageContext);

    // global redux state for company (passed in from other route)
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);

    // event handler for submit click
    const onSubmit = () => { 
        workflowButtonCss.current = 'modal-button-full-blue';
        workflowOptOut.current = true; 
        workflowReviewAction.current = false; 
        setWorkflowAction(workflowAction => workflowAction = 'Submit');
        setWorkflowNewStatus(workflowNewStatus => workflowNewStatus = 'Initial Review');
        setWorkflowModal(workflowModal => workflowModal = true);
        setWorkflowActionId(workflowActionId => workflowActionId = process.env.REACT_APP_SUBMIT_ACTION_ID); 
    }

    // event handler for accept click
    const onAccept = () => {
        workflowButtonCss.current = 'modal-button-full-green';
        workflowOptOut.current = false; 
        workflowReviewAction.current = false; 
        setWorkflowAction(workflowAction => workflowAction = 'Accept');
        if (status == 'Initial Review'){
            setWorkflowNewStatus(workflowNewStatus => workflowNewStatus = 'Final Review');
            setWorkflowActionId(workflowActionId => workflowActionId = process.env.REACT_APP_INITIAL_REVIEW_ACTION_ID); 
        }
        else if (status == 'Final Review') {
            setWorkflowNewStatus(workflowNewStatus => workflowNewStatus = 'Accepted');
            setWorkflowActionId(workflowActionId => workflowActionId = process.env.REACT_APP_FINAL_REVIEW_ACTION_ID); 
        }
        setWorkflowModal(workflowModal => workflowModal = true);
    }

    // event handler for reject click
    const onReject = () => {
        workflowButtonCss.current = 'modal-button-full-red';
        workflowOptOut.current = false; 
        workflowReviewAction.current = false; 
        setWorkflowAction(workflowAction => workflowAction = 'Reject');
        if (status == 'Initial Review'){
            setWorkflowActionId(workflowActionId => workflowActionId = process.env.REACT_APP_INITIAL_REVIEW_ACTION_ID); 
        }
        else if (status == 'Final Review') {
            setWorkflowActionId(workflowActionId => workflowActionId = process.env.REACT_APP_FINAL_REVIEW_ACTION_ID); 
        }
        setWorkflowNewStatus(workflowNewStatus => workflowNewStatus = 'Rejected');
        setWorkflowModal(workflowModal => workflowModal = true);
    }

    // event handler for re-open click 
    const onReopen = () => {
        workflowButtonCss.current = 'modal-button-full-blue';
        workflowOptOut.current = false; 
        workflowReviewAction.current = false; 
        setWorkflowAction(workflowAction => workflowAction = 'Re-open');
        setWorkflowNewStatus(workflowNewStatus => workflowNewStatus = 'Pending');
        setWorkflowModal(workflowModal => workflowModal = true);
        setWorkflowActionId(workflowActionId => workflowActionId = process.env.REACT_APP_REOPEN_ACTION_ID); 
    }

    // event handler for reinstate click 
    const onReinstate = () => {
        workflowButtonCss.current = 'modal-button-full-red'; 
        workflowOptOut.current = false; 
        workflowReviewAction.current = false; 
        setWorkflowAction(workflowAction => workflowAction = 'Reinstate'); 
        setWorkflowNewStatus(workflowNewStatus => workflowNewStatus = 'Pending'); 
        setWorkflowModal(workflowModal => workflowModal = true); 
        setWorkflowActionId(workflowActionId => workflowActionId = process.env.REACT_APP_REINSTATE_ACTION_ID); 
    }

    // Multi Workflowbutton components
    const MultiWorkflowButton = ({ tag, func,disabled=false }) => {
        if (tag !== 'Reject' && tag !== 'Reinstate') {
            return (
                <ButtonComponent disabled = {disabled}
                    border={'#fcd800 1px solid'} background={'#fcd800'} color={'#001317'}
                    tag={tag} onButtonClick={() => func()} disabledBorder={'#BDBDBD 1px solid'} disabledBackground={'#FCF5CA'} disabledColor={'#BDBDBD'} />)
        } else {
            return (
                <ButtonComponent disabled = {disabled}
                    border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                    tag={tag} onButtonClick={() => func()} disabledBorder={'#BDBDBD 1px solid'} disabledBackground={'white'} disabledColor={'#BDBDBD'} />)
        }
    }

    // ADD TOOLTIPS TO DENOTE WHEN ACTION IS DISABLED
    return(
        <>
            { status == 'Pending' && userEntitlementId == process.env.REACT_APP_SUBMITTER_ROLE_ID && !disable ? 
            <>
                {/* Role: [Submitter], status: PENDING */}
                <MultiWorkflowButton func={()=>onSubmit()} tag='Submit'/>
            </>
            : status == 'Rejected' && userEntitlementId == process.env.REACT_APP_SUBMITTER_ROLE_ID && !disable 
            && process.env.REACT_APP_ALLOW_REINSTATE == '1' ?
            <>
                {/* Role: [Submitter], status: REJECTED (with Reinstate) */}
                <MultiWorkflowButton tag="Submit" func={()=>onSubmit()}/>
                <MultiWorkflowButton tag="Reinstate" func={()=>onReinstate()}/>
            </>
            : status == 'Rejected' && userEntitlementId == process.env.REACT_APP_SUBMITTER_ROLE_ID && !disable 
            && process.env.REACT_APP_ALLOW_REINSTATE == '0' ?
            <>
                {/* Role: [Submitter], status: REJECTED (no Reinstate) */}
                <MultiWorkflowButton tag="Submit" func={()=>onSubmit()}/>
            </>
            : (status == 'Pending' || status == 'Rejected') ? 
            <>
                {/* Role: [CCRM, Reviewer],  status: PENDING */}
                <MultiWorkflowButton  tag="Submit" disabled={true}/>
            </>
            : status == 'Initial Review' && userEntitlementId == process.env.REACT_APP_CCRM_ROLE_ID && !disable ? 
            <>
                {/* Role: [CCRM], status: Initial Review */}
                <MultiWorkflowButton tag='Accept' func={()=>onAccept()}/>
                <MultiWorkflowButton tag='Reject' func={()=>onReject()}/>                    
            </>
            : status == 'Initial Review'  ? 
            <> 
                {/* Role: [Reviewer, Submitter], status: Initial Review */}
                <MultiWorkflowButton tag='Accept' disabled={true}/>
                <MultiWorkflowButton tag='Reject' disabled={true}/>
            </>
            : status == 'Final Review' && userEntitlementId == process.env.REACT_APP_REVIEWER_ROLE_ID && !disable ? 
            <> 
                {/* Role: [Reviewer], status: FINAL REVIEW */}
                <MultiWorkflowButton tag='Accept' func={()=>onAccept()}/>
                <MultiWorkflowButton tag='Reject' func={()=>onReject()}/>                    
            </>
            : status == 'Final Review' ?
            <>
                {/* Role: [CCRM, Submitter], status: FINAL REVIEW */}
                <MultiWorkflowButton tag='Accept' disabled={true}/>
                <MultiWorkflowButton tag='Reject' disabled={true}/>
            </>
            : status == 'Accepted' && enableReopen && userEntitlementId == process.env.REACT_APP_SUBMITTER_ROLE_ID && !disable ? 
            <>
                {/* Role: [Submitter], status: ACCEPTED */}
                <MultiWorkflowButton tag='Re-open' func={()=>onReopen()}/>
            </>
            : status == 'Accepted' ?
            <>
                {/* Role: [CCRM, Reviewer], status: ACCEPTED */}
                <MultiWorkflowButton tag='Re-open' disabled={true}/>
            </>
            :<>
                <span style={{color: 'transparent'}}>
                    ----
                </span>
            </>}
        </>
    );
} 

export default WorkflowButton;  